import React, { useEffect, useState } from 'react';

import Moment from 'moment';
import { useTheme } from 'styled-components';

import { useHistory, useLocation } from 'react-router-dom';

import { FaFileExcel, FaFilePdf, FaFilter } from 'react-icons/fa';
import { FaCartPlus } from 'react-icons/fa';
import { MdCheckBoxOutlineBlank } from 'react-icons/md';
import { MdCheckBox } from 'react-icons/md';
import { FaEye } from 'react-icons/fa';
import { FaWhatsapp } from 'react-icons/fa';
import { IoMdArrowDropup, IoMdArrowDropdown, IoMdClose } from 'react-icons/io';

import qs from 'qs';

import { onlyNumbers } from '~/helpers/number';

import api from '~/services/api';

import { exportCsv } from '~/helpers/csv';
import { exportPdf } from '~/helpers/pdf';

import {
  Scroll,
  Container,
  Header,
  Area,
  Grid,
  GridLine,
  GridHeadItem,
  GridItem,
  Progress,
  Loading,
  Empty,
  Stack,
  Footer,
  Label,
  Cancel,
  Button,
  Input,
  Box,
  Checkbox,
  Summary,
} from '~/components';

import {
  LoadArea,
  FiltersZone,
  CheckBtn,
  WhatsappBtn,
  DetailBtn,
  ShowItensBtn,
  IdBtn,
  FiltersZoneHeader,
  FiltersZoneContent,
  Reflection,
  ClearFiltersBtn,
  Thumb,
  Align,
} from './styles';

import Agrupamento from './Agrupamento';
import DetalhesDoPedido from './DetalhesDoPedido';

import PedidoType from '~/@types/pedido';
import { Legend } from '../VendasPorCanal/styles';

let lang = require('moment/locale/pt-br');
Moment.locale('pt-br', lang);

const Pedidos: React.FC = () => {
  const history = useHistory();
  const { colors } = useTheme();

  const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  };

  let query = useQuery();

  const [inLoad, setInLoad] = useState(false);
  const [pedidos, setPedidos] = useState<PedidoType[]>([]);
  const [pedidosSelecionados, setPedidosSelecionados] = useState<PedidoType[]>(
    [],
  );
  const [detalhesVisiveis, setDetalhesvisiveis] = useState<string[]>([]);

  // FILTROS
  const [filtersVisible, setFiltersVisible] = useState(false);

  // INTERVALO DE DATAS (FILTRO)
  const [status, setStatus] = useState('');
  const [busca, setBusca] = useState('');
  const [integradoERP, setIntegradoERP] = useState('NAO');
  const [faturado, setFaturado] = useState('NAO');
  const [periodicidade, setPeriodicidade] = useState('hoje');
  const [dtinicio, setDtinicio] = useState('');
  const [dtfinal, setDtfinal] = useState('');

  const toggleDetalhesPedido = (pIddPedido: string) => {
    if (detalhesVisiveis.includes(pIddPedido)) {
      setDetalhesvisiveis([
        ...detalhesVisiveis.filter(cItem => cItem !== pIddPedido),
      ]);
    } else {
      setDetalhesvisiveis([...detalhesVisiveis, pIddPedido]);
    }
  };

  const allInCheck = () => {
    return pedidosSelecionados.length === pedidos.length;
  };

  const checkAll = () => {
    if (allInCheck()) {
      setPedidosSelecionados([]);
    } else {
      setPedidosSelecionados([...pedidos]);
    }
  };

  const checkIsCheck = (pPedido: PedidoType) => {
    return pedidosSelecionados.filter(
      (cPedido: PedidoType) => cPedido.idpedido === pPedido.idpedido,
    ).length
      ? true
      : false;
  };

  const toggleCheck = (pPedido: PedidoType) => {
    if (checkIsCheck(pPedido)) {
      setPedidosSelecionados([
        ...pedidosSelecionados.filter(
          cPedido => cPedido.idpedido !== `${pPedido.idpedido}`,
        ),
      ]);
    } else {
      setPedidosSelecionados([...pedidosSelecionados, pPedido]);
    }
  };

  // DETALHES DO PEDIDO
  const visualizarPedido = (pPedido: PedidoType) => {
    history.push(`pedido/${pPedido.idpedido}`);
  };

  // CONTACTAR VIA WHATSAPP
  const contactarViaWhatsapp = (pPedido: PedidoType) => {
    const urlWhatsapp = `https://api.whatsapp.com/send/?phone=55${onlyNumbers(
      pPedido.cliente.telefone,
    )}
    &text=Olá ${
      pPedido.cliente.nome
    }, Estou entrando em contato referente ao pedido ${
      pPedido.idpedido
    } no valor de ${
      pPedido.precototalformatado
    }&type=phone_number&app_absent=0`;
    window.open(urlWhatsapp, 'blank');
  };

  // FILTROS
  const toggleFilters = () => {
    setFiltersVisible(!filtersVisible);
  };

  // RESETAR FILTROS
  const resetar = () => {
    setStatus('');
    setIntegradoERP('');
    setFaturado('');
    setPeriodicidade('');
    setDtfinal('');
    setDtinicio('');
    aplicarFiltros('', '', '', '', '', '', '');
    toggleFilters();
  };

  const aplicarFiltros = async (
    pIntegradoERP: string,
    pFaturado: string,
    pPeriodicidade: string,
    pDtfinal: string,
    pDtinicio: string,
    pBusca: string,
    pStatus: string,
  ) => {
    try {
      setInLoad(true);
      setPedidos([]);
      setPedidosSelecionados([]);
      setFiltersVisible(false);
      setDetalhesvisiveis([]);

      const urlParams = qs.stringify(
        {
          status: pStatus && pStatus !== '' ? pStatus : null,
          integradoerp:
            pIntegradoERP && pIntegradoERP !== '' ? pIntegradoERP : null,
          faturado: pFaturado && pFaturado !== '' ? pFaturado : null,
          periodicidade:
            pPeriodicidade && pPeriodicidade !== '' ? pPeriodicidade : null,
          dtfinal: pDtfinal && pDtfinal !== '' ? pDtfinal : null,
          dtinicio: pDtinicio && pDtinicio !== '' ? pDtinicio : null,
          busca: pBusca && pBusca !== '' ? pBusca : null,
        },
        {
          skipNulls: true,
        },
      );

      history.push({
        pathname: '/pedidos',
        search: `?${urlParams}`,
      });

      const response = await api.get(`pedidos?${urlParams}`);

      const { data } = response;

      if (data) {
        setPedidos(data);
      }

      setInLoad(false);
    } catch (e) {
      setInLoad(false);
    }
  };

  // Pedidos
  const buscarPedidos = async (pStrSearch: string) => {
    query.set('busca', pStrSearch);
    history.push({
      pathname: '/pedidos',
      search: `?${query.toString()}`,
    });
  };

  const gerarRelatorioCSV = () => {
    let data: string[] = [];

    data.push(
      'IDPEDIDO;TID;INTEGRADO;FATURADO;DATA;CLIENTE;STATUS;SITUAÇÃO;VALOR',
    );

    let c;
    for (c in pedidos) {
      const pedido = pedidos[c];
      data.push(
        `${pedido.idpedido};${pedido.tiderp};${
          pedido.tiderp !== '' ? 'SIM' : 'NÃO'
        };${pedido.numnfe !== '' ? 'SIM' : 'NÃO'};${pedido.dt};${
          pedido.cliente.nome
        };${pedido.status};${pedido.situacao};${pedido.precototal}`,
      );
    }

    const csv = data.join('\n');

    exportCsv(csv, 'PEDIDOS');
  };

  const gerarRelatorioPDF = () => {
    const cabecalho = [
      'IDPEDIDO',
      'TID',
      'INTEGRADO',
      'FATURADO',
      'DATA',
      'CLIENTE',
      'STATUS',
      'SITUACAO',
      'VALOR',
    ];

    const data: string[][] = [];

    let c;
    for (c in pedidos) {
      const pedido = pedidos[c];
      const linha: string[] = [];

      linha.push(pedido.idpedido);
      linha.push(pedido.tiderp);
      linha.push(`${pedido.tiderp !== '' ? 'SIM' : 'NÃO'}`);
      linha.push(`${pedido.numnfe !== '' ? 'SIM' : 'NÃO'}`);
      linha.push(pedido.dt);
      linha.push(pedido.cliente.nome);
      linha.push(pedido.status);
      linha.push(pedido.situacao);
      linha.push(pedido.precototalformatado);

      data.push(linha);
    }

    exportPdf(cabecalho, data, 'PEDIDOS');
  };

  const exibirReflexao = () => {
    if (
      query.get('busca') ||
      query.get('integradoerp') ||
      query.get('faturado') ||
      query.get('periodicidade') ||
      query.get('dtfinal') ||
      query.get('dtinicio') ||
      query.get('status')
    ) {
      return true;
    }
    return false;
  };

  const verificarReflexao = (pNome: string) => {
    if (query.get(pNome)) {
      return true;
    }
    return false;
  };

  const removerReflexao = (pNome: string) => {
    query.delete(pNome);
    history.push({
      pathname: '/pedidos',
      search: `?${query.toString()}`,
    });
  };

  useEffect(() => {
    const sBusca = query.get('busca') || '';
    const sIntegradoERP = query.get('integradoerp') || '';
    const sFaturado = query.get('faturado') || '';
    const sPeridiocidade = query.get('periodicidade') || '';
    const sDtFinal = query.get('dtfinal') || '';
    const sDtInicio = query.get('dtinicio') || '';
    const sStatus = query.get('status') || '';

    setIntegradoERP(sIntegradoERP);
    setFaturado(sFaturado);
    setPeriodicidade(sPeridiocidade);
    setDtfinal(sDtFinal);
    setDtinicio(sDtInicio);
    setBusca(sBusca);
    setStatus(sStatus);

    aplicarFiltros(
      sIntegradoERP,
      sFaturado,
      sPeridiocidade,
      sDtFinal,
      sDtInicio,
      sBusca,
      sStatus,
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  return (
    <>
      {inLoad ? <Progress /> : null}

      <Scroll>
        <Container>
          <Header
            title="Pedidos"
            subtitle="Gerencie a sincronização dos pedidos"
            isSearch
            onSearch={buscarPedidos}
            placeholder="Buscar em pedidos..."
            isFilters
            toggleFilters={toggleFilters}
            icon={
              <>
                <FaCartPlus size={32} color={colors.IC1} />
              </>
            }
          />

          {filtersVisible ? (
            <FiltersZone>
              <FiltersZoneHeader>
                <div>
                  <FaFilter size={22} color={colors.IC1} />
                  <h1>FILTROS</h1>
                </div>
                <button onClick={toggleFilters} title="Fechar os filtros">
                  <IoMdArrowDropup size={36} color={colors.IC1} />
                </button>
              </FiltersZoneHeader>
              <FiltersZoneContent>
                <Stack>
                  <Label
                    number="1"
                    label="Status"
                    subtitle="Selecione o status do pedido"
                    status={!!status}
                  />
                  <Box>
                    <Checkbox
                      label="Aprovado"
                      onClick={() => setStatus('aprovado')}
                      status={status === 'aprovado'}
                    />
                    <Checkbox
                      label="Cancelado"
                      onClick={() => setStatus('cancelado')}
                      status={status === 'cancelado'}
                    />
                    <Checkbox
                      label="Aguardando Dados"
                      onClick={() => setStatus('aguardando-dados')}
                      status={status === 'aguardando-dados'}
                    />
                    <Checkbox
                      label="Aguardando Pagto"
                      onClick={() => setStatus('aguardando-pagto')}
                      status={status === 'aguardando-pagto'}
                    />
                    <Checkbox
                      label="Entregue"
                      onClick={() => setStatus('entregue')}
                      status={status === 'entregue'}
                    />
                  </Box>
                </Stack>

                <Stack>
                  <Label
                    number="1"
                    label="Integrado ao ERP?"
                    subtitle="Pediodos já sincronizados ou não"
                    status={!!integradoERP}
                  />
                  <Box>
                    <Checkbox
                      label="SIM"
                      onClick={() => setIntegradoERP('SIM')}
                      status={integradoERP === 'SIM'}
                    />
                    <Checkbox
                      label="NÃO"
                      onClick={() => setIntegradoERP('NAO')}
                      status={integradoERP === 'NAO'}
                    />
                  </Box>
                </Stack>

                <Stack>
                  <Label
                    number="2"
                    label="Faturado?"
                    subtitle="Pediodos já faturados ou não"
                    status={!!faturado}
                  />
                  <Box>
                    <Checkbox
                      label="SIM"
                      onClick={() => setFaturado('SIM')}
                      status={faturado === 'SIM'}
                    />
                    <Checkbox
                      label="NÃO"
                      onClick={() => setFaturado('NAO')}
                      status={faturado === 'NAO'}
                    />
                  </Box>
                </Stack>

                <Stack>
                  <Label
                    number="3"
                    label="Intervalo"
                    subtitle="Selecione o intervalo desejado"
                    status={!!periodicidade}
                  />
                  <Box>
                    <Checkbox
                      label="Tudo"
                      onClick={() => setPeriodicidade('tudo')}
                      status={periodicidade === 'tudo'}
                    />
                    <Checkbox
                      label="Hoje"
                      onClick={() => setPeriodicidade('hoje')}
                      status={periodicidade === 'hoje'}
                    />
                    <Checkbox
                      label="Semana"
                      onClick={() => setPeriodicidade('semana')}
                      status={periodicidade === 'semana'}
                    />
                    <Checkbox
                      label="Personalizado"
                      onClick={() => setPeriodicidade('intervalo')}
                      status={periodicidade === 'intervalo'}
                    />
                  </Box>
                </Stack>

                {periodicidade === 'intervalo' ? (
                  <Stack>
                    <Label
                      number="3.1"
                      label="De:"
                      subtitle="Informe uma data de início"
                      status={!!dtinicio}
                    />
                    <Input
                      type="text"
                      placeholder="Data de início..."
                      value={dtinicio}
                      onChange={e => setDtinicio(e.target.value)}
                      mask={'99/99/9999'}
                    />
                  </Stack>
                ) : null}

                {periodicidade === 'intervalo' ? (
                  <Stack>
                    <Label
                      number="3.2"
                      label="Até:"
                      subtitle="Informe uma data limite"
                      status={!!dtfinal}
                    />
                    <Input
                      type="text"
                      placeholder="Data limite..."
                      value={dtfinal}
                      onChange={e => setDtfinal(e.target.value)}
                      mask={'99/99/9999'}
                    />
                  </Stack>
                ) : null}

                <Footer>
                  <Button
                    onClick={() => {
                      toggleFilters();

                      aplicarFiltros(
                        integradoERP,
                        faturado,
                        periodicidade,
                        dtfinal,
                        dtinicio,
                        busca,
                        status,
                      );
                    }}
                  >
                    APLICAR
                  </Button>
                  <Cancel onClick={resetar}>Resetar</Cancel>
                </Footer>
              </FiltersZoneContent>
            </FiltersZone>
          ) : null}

          <Summary>
            {pedidos.length ? (
              <h1>
                {pedidos.length > 1
                  ? `${pedidos.length} pedidos em tela`
                  : `Um pedido em tela`}
              </h1>
            ) : (
              <h1>Nenhum pedido em tela</h1>
            )}
            <div>
              {pedidos.length ? (
                <>
                  <button
                    className="excel"
                    onClick={gerarRelatorioCSV}
                    title="Exportar para Excel"
                  >
                    <FaFileExcel size={22} color={colors.IC2} />
                    <div>
                      <h3>EXPORTAR</h3>
                      <h2>EXCEL</h2>
                    </div>
                  </button>
                  <button
                    className="pdf"
                    onClick={gerarRelatorioPDF}
                    title="Exportar para PDF"
                  >
                    <FaFilePdf size={22} color={colors.IC2} />
                    <div>
                      <h3>EXPORTAR</h3>
                      <h2>PDF</h2>
                    </div>
                  </button>
                </>
              ) : null}
            </div>
          </Summary>

          {exibirReflexao() ? (
            <Reflection>
              <h1>Filtros ativos:</h1>
              <main>
                {verificarReflexao('busca') ? (
                  <div>
                    <button onClick={() => removerReflexao('busca')}>
                      <IoMdClose size={26} color={colors.IC1} />
                    </button>
                    <span>
                      <strong>BUSCA POR:</strong>
                      <small>{busca}</small>
                    </span>
                  </div>
                ) : null}
                {verificarReflexao('status') ? (
                  <div>
                    <button onClick={() => removerReflexao('status')}>
                      <IoMdClose size={26} color={colors.IC1} />
                    </button>
                    <span>
                      <strong>STATUS:</strong>
                      <small>{status}</small>
                    </span>
                  </div>
                ) : null}
                {verificarReflexao('integradoerp') ? (
                  <div>
                    <button onClick={() => removerReflexao('integradoerp')}>
                      <IoMdClose size={26} color={colors.IC1} />
                    </button>
                    <span>
                      <strong>INTEGRADO:</strong>
                      <small>{integradoERP}</small>
                    </span>
                  </div>
                ) : null}
                {verificarReflexao('faturado') ? (
                  <div>
                    <button onClick={() => removerReflexao('faturado')}>
                      <IoMdClose size={26} color={colors.IC1} />
                    </button>
                    <span>
                      <strong>FATURADO:</strong>
                      <small>{faturado}</small>
                    </span>
                  </div>
                ) : null}

                {verificarReflexao('periodicidade') ? (
                  <div>
                    <button onClick={() => removerReflexao('periodicidade')}>
                      <IoMdClose size={26} color={colors.IC1} />
                    </button>
                    <span>
                      <strong>PERIODICIDADE:</strong>
                      <small>{periodicidade}</small>
                    </span>
                  </div>
                ) : null}

                {verificarReflexao('dtinicio') ? (
                  <div>
                    <button onClick={() => removerReflexao('dtinicio')}>
                      <IoMdClose size={26} color={colors.IC1} />
                    </button>
                    <span>
                      <strong>DATA INICIAL:</strong>
                      <small>{dtinicio}</small>
                    </span>
                  </div>
                ) : null}

                {verificarReflexao('dtfinal') ? (
                  <div>
                    <button onClick={() => removerReflexao('dtfinal')}>
                      <IoMdClose size={26} color={colors.IC1} />
                    </button>
                    <span>
                      <strong>DATA FINAL:</strong>
                      <small>{dtfinal}</small>
                    </span>
                  </div>
                ) : null}
              </main>
              <ClearFiltersBtn onClick={resetar}>
                LIMPAR TODOS OS FILTROS
              </ClearFiltersBtn>
            </Reflection>
          ) : null}

          {pedidosSelecionados.length ? (
            <Agrupamento
              dismissAll={() => setPedidosSelecionados([])}
              pedidosSelecionados={pedidosSelecionados}
            />
          ) : null}

          {!inLoad ? (
            <Area>
              {pedidos.length ? (
                <Grid>
                  <GridLine>
                    <GridHeadItem title="" width={50}>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                        }}
                      >
                        <CheckBtn onClick={checkAll}>
                          {allInCheck() ? (
                            <MdCheckBox size={22} color={colors.IC1} />
                          ) : (
                            <MdCheckBoxOutlineBlank
                              size={22}
                              color={colors.IC1}
                            />
                          )}
                        </CheckBtn>
                      </div>
                    </GridHeadItem>
                    <GridHeadItem title="ID" width={100} />
                    <GridHeadItem title="Canal" width={80} />
                    <GridHeadItem title="Data" width={160} />
                    <GridHeadItem title="Cliente" />
                    <GridHeadItem title="Status" width={120} />
                    <GridHeadItem title="Valor" width={120} />
                    <GridHeadItem title="" width={120} />
                  </GridLine>

                  {pedidos.map((pedido, key) => (
                    <>
                      <GridLine
                        key={pedido.idpedido}
                        className={checkIsCheck(pedido) ? 'selected' : ''}
                      >
                        <GridItem width={50}>
                          <Align>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                              }}
                            >
                              <CheckBtn onClick={() => toggleCheck(pedido)}>
                                {checkIsCheck(pedido) ? (
                                  <MdCheckBox size={22} color={colors.IC1} />
                                ) : (
                                  <MdCheckBoxOutlineBlank
                                    size={22}
                                    color={colors.IC1}
                                  />
                                )}
                              </CheckBtn>
                            </div>
                          </Align>
                        </GridItem>

                        <GridItem width={100}>
                          <Align>
                            <IdBtn
                              onClick={() =>
                                toggleDetalhesPedido(`${pedido.idpedido}`)
                              }
                            >
                              <strong>{pedido.idpedido}</strong>
                            </IdBtn>
                          </Align>
                        </GridItem>
                        <GridItem width={80}>
                          <Legend>
                            <Thumb>
                              <img
                                src={
                                  pedido.iconecanal
                                    ? pedido.iconecanal
                                    : `https://dummyimage.com/80x80/fff/000&text=${pedido.canal}`
                                }
                                title={pedido.canal}
                                alt={pedido.canal}
                              />
                            </Thumb>
                            <h1>{pedido.canal}</h1>
                          </Legend>
                        </GridItem>

                        <GridItem width={160}>
                          <Align>
                            <strong>{pedido.dt}</strong>
                            <br />
                            <small>
                              {Moment(pedido.dt, 'DD/MM/YYYY HH:mm').fromNow()}
                            </small>
                          </Align>
                        </GridItem>
                        <GridItem>
                          <Align>
                            {pedido.cliente.tipo === 'PF' ? (
                              <>
                                <strong>
                                  {pedido.cliente.nome}{' '}
                                  {pedido.cliente.sobrenome}
                                </strong>
                                <br />
                                <small>{pedido.cliente.cpf}</small>
                              </>
                            ) : (
                              <>
                                <strong>{pedido.cliente.razaosocial}</strong>
                                <br />
                                <small>{pedido.cliente.cnpj}</small>
                              </>
                            )}
                          </Align>
                        </GridItem>
                        <GridItem width={120}>
                          <Align>
                            <span
                              style={{
                                fontWeight: '700',
                                padding: 5,
                                borderRadius: 5,
                                textTransform: 'uppercase',
                                background:
                                  pedido.statuscor && pedido.statuscor !== ''
                                    ? pedido.statuscor
                                    : '#fff',
                                fontSize: 12,
                                color: pedido.status
                                  .toLocaleLowerCase()
                                  .includes('aguardando')
                                  ? '#000'
                                  : '#fff',
                              }}
                            >
                              {pedido.status}
                            </span>
                          </Align>
                        </GridItem>

                        <GridItem width={120}>
                          <Align>
                            <strong>{pedido.precototalformatado}</strong>
                          </Align>
                        </GridItem>

                        <GridItem width={120}>
                          <Align>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                              }}
                            >
                              <ShowItensBtn
                                onClick={() =>
                                  toggleDetalhesPedido(`${pedido.idpedido}`)
                                }
                                title="Visualizar Itens do Pedido"
                              >
                                {detalhesVisiveis.includes(
                                  `${pedido.idpedido}`,
                                ) ? (
                                  <IoMdArrowDropup
                                    size={26}
                                    color={colors.IC1}
                                  />
                                ) : (
                                  <IoMdArrowDropdown
                                    size={26}
                                    color={colors.IC1}
                                  />
                                )}
                              </ShowItensBtn>

                              <DetailBtn
                                onClick={() => visualizarPedido(pedido)}
                                title="Visualizar Detalhes do Pedido"
                              >
                                <FaEye size={22} color={colors.IC1} />
                              </DetailBtn>
                              <WhatsappBtn
                                onClick={() => contactarViaWhatsapp(pedido)}
                                title="Entrar em contato Whatsapp"
                              >
                                <FaWhatsapp size={22} color={colors.GREEN} />
                              </WhatsappBtn>
                            </div>
                          </Align>
                        </GridItem>
                      </GridLine>
                      {detalhesVisiveis.includes(pedido.idpedido) ? (
                        <DetalhesDoPedido pedido={pedido} />
                      ) : null}
                    </>
                  ))}
                </Grid>
              ) : (
                <Empty>Nenhum pedido encontrado momento</Empty>
              )}
            </Area>
          ) : (
            <LoadArea>
              <Loading color={colors.IC1} size={42} />
            </LoadArea>
          )}
        </Container>
      </Scroll>
    </>
  );
};

export default Pedidos;
